const WALLET_PASS_BUILDER_COPY = {
  branding: {
    squareLogo: {
      description: "Used across key placements on both passes:\n• Apple icon on the lock screen and in Mail notifications\n• Apple logo in the top-left corner of the pass\n• Google logo in the top-left corner of the pass\n\nDiobox generates the required variations automatically. Transparent PNG • 660×660 px.",
      dropLabel: "660×660",
    },
    horizontalLogo: {
      description: "Shown in the top-left corner of the Apple pass. When provided, it replaces both the Square Logo and the Brand Name in that position.\n\nTransparent PNG • 480×150 px",
      dropLabel: "480×150",
    },
    appleBanner: {
      description: "Wide image displayed behind the primary fields on the Apple pass.\n\nPNG or JPEG • Use a clean image without text • 1125×294 px recommended • Up to 2 MB",
      dropLabel: "1125×294",
    },
    googleHero: {
      description: "Wide image displayed across the full width of the Google pass, below the pass details.\n\nPNG or JPEG • Use a clean image without text • 1860×600 px recommended • Up to 2 MB",
      dropLabel: "1860×600",
    },
  },
  front: {
    logoText: "Short text shown next to the logo at the top of the pass. Keep it under 20 characters so it fits on all devices. Hidden on Apple passes when a Horizontal Logo is uploaded, since the logo takes its place.",
    headerField: "Appears in the top-right corner of Apple Wallet passes. Best for short details such as a start time or abbreviated date. This is the only field when several passes are stacked in Apple Wallet, so it should help them find the right one.",
    eventTitle: "The main title of the pass, typically the event name. Keep it to one or two short lines so it stays readable.",
    eventLocation: "A single wide field shown just below the Event Title on Apple and just above it on Google. Suited to longer text such as a full venue name, a complete date, or door times.",
    guestName: "Appears in the middle of the pass, close to the QR code, which makes it easy for staff to match the pass to the guest at check-in.",
    auxiliaryFields: "Two small fields at the bottom of the pass, just above the QR code. Best for details staff may need at the door, such as table or seat number, ticket type, or registration info.",
    qrCode: "Adds the guest's QR code to the pass for check-in, session tracking, and other scanning throughout the event.\n\nNote: Wallet passes support static QR codes only. If Temporal QR security is enabled, guests must use the rotating QR code in their confirmation email instead.",
  },
  eventTitle: {
    banner: "Show below the Apple Banner Image. When unchecked, the title is placed over the image",
  },
  labelHelp: {
    appleOnly: "The label can only be customized on Apple passes",
    googleTicketHolder: "Google always labels this row \"Ticket Holder\" and translates it to the guest's device language",
  },
  back: {
    additionalInformation: "Space for supporting information and interactive contact details. Unlike the front, this section supports longer text and tappable links such as email addresses, phone numbers, and website URLs. On Google Wallet, this content appears in the pass details view.",
    addSection: "Add Section",
  },
  preview: {
    frontTitle: "FRONT OF THE PASS PREVIEW",
    backTitle: "BACK OF THE PASS PREVIEW",
  },
} as const

export default WALLET_PASS_BUILDER_COPY
